module.exports = __webpack_public_path__ + "img/globe.5f9fc329.svg";